
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const hardwareUpgradeChallenge: Challenge = {
  id: 'hardware-upgrade',
  title: 'Hardware Upgrade Decision',
  description: 'New mining hardware has been released. How will you approach the upgrade?',
  options: [
    {
      text: 'Immediately upgrade all hardware',
      outcome: 'The new hardware provides a significant efficiency boost, but at a high initial cost.',
      kpiEffects: {
        efficiency: 7,
        profitMargin: -5,
        uptime: 1
      },
      experienceGain: 25,
      skillUnlock: skills.find(s => s.id === 'hardware-maintenance')
    },
    {
      text: 'Conduct a phased rollout',
      outcome: 'You minimize disruption with a careful transition, balancing costs and benefits.',
      kpiEffects: {
        efficiency: 4,
        profitMargin: -2,
        uptime: -1
      },
      experienceGain: 20,
      skillUnlock: skills.find(s => s.id === 'strategic-planning')
    },
    {
      text: 'Wait for second-generation hardware',
      outcome: 'You avoided early-adopter issues but fell behind competitors temporarily.',
      kpiEffects: {
        efficiency: -2,
        profitMargin: 3
      },
      experienceGain: 15
    }
  ],
  difficulty: 3,
  requiredSkills: ['financial-planning']
}
